const planos = [
    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( 2x/semana ) - mensal",
        tx_adesão:"R$99,00",
        duração:"1 mês",
        pagamento:"À vista",
        parcela:"R$399,00",
        valorTotal:399,
        source:"https://venda.nextfit.com.br/75f405a1-80c5-4194-a78c-4f17ba9beef3"
    },
    
    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- 2x/semana - semestral",
    //    tx_adesão:"R$99,00",
    //    duração:"6 meses",
    //    pagamento:"Em até 4x",
    //    parcela:"R$523,50",
    //    valorTotal:2094,
    //    source:""
    //},

    {
        modalidade:"lutas( jiu jitsu / boxe )",
        tipo:"( acesso livre ) - anual",
        tx_adesão:"R$99,00",
        duração:"12 meses",
        pagamento:"Em até 6x",
        parcela:"R$798,00",
        valorTotal:4788,
        source:"https://venda.nextfit.com.br/26042357-4b68-4bf0-9114-4538985bee4e"
    },

    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- 3x/semana - mensal",
    //    tx_adesão:"R$99,00",
    //    duração:"1 mês",
    //    pagamento:"À vista",
    //    parcela:"R$449,00",
    //    valorTotal:449,
    //    source:""
    //},
    //
    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- 3x/semana - semestral",
    //    tx_adesão:"R$99,00",
    //    duração:"6 meses",
    //    pagamento:"Em até 4x",
    //    parcela:"R$598,50",
    //    valorTotal:2394,
    //    source:""
    //},
//
    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- 3x/semana - anual",
    //    tx_adesão:"R$99,00",
    //    duração:"12 meses",
    //    pagamento:"Em até 6x",
    //    parcela:"R$698,00",
    //    valorTotal:4188,
    //    source:""
    //},
//
    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- acesso livre - mensal",
    //    tx_adesão:"R$99,00",
    //    duração:"1 mês",
    //    pagamento:"À vista",
    //    parcela:"R$449,00",
    //    valorTotal:449,
    //    source:""
    //},
    //
    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- acesso livre - semestral",
    //    tx_adesão:"R$99,00",
    //    duração:"6 meses",
    //    pagamento:"Em até 4x",
    //    parcela:"R$673,50",
    //    valorTotal:2694,
    //    source:""
    //},
//
    //{
    //    modalidade:"lutas(jiu jitsu / boxe)",
    //    tipo:"- acesso livre - anual",
    //    tx_adesão:"R$99,00",
    //    duração:"12 meses",
    //    pagamento:"Em até 6x",
    //    parcela:"R$798,00",
    //    valorTotal:4788,
    //    source:""
    //},
//
    //{
    //    modalidade:"black belt",
    //    tipo:"- acesso livre - anual",
    //    tx_adesão:"Grátis",
    //    duração:"12 meses",
    //    pagamento:"Em até 10x",
    //    parcela:"R$418,80",
    //    valorTotal:4188,
    //    source:""
    //},

    {
        modalidade:"acesso livre",
        tipo:"- recorrente",
        tx_adesão:"Grátis",
        duração:"12 meses",
        pagamento:"À vista",
        parcela:"R$419,00",
        valorTotal:419,
        source:"https://venda.nextfit.com.br/9113b6f0-1380-426f-b254-a8139bcfc756/contratos"
    }

    
]

export default planos;